export const VIEW_SETTINGS_SECTION = "viewSettingsSection";
export const VIEW_FILE_STORAGE = "viewFileStorage";
export const VIEW_TASKS_SECTION = "viewTask";
export const VIEW_HANDBOOK_APPROVALS = "viewHandbookApprovals";
